"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.MetricRule = exports.MetricRuleValueNames = exports.MetricRuleValueTypes = exports.MetricRuleClassName = void 0;
const ModelCommon_1 = require("./ModelCommon");
exports.MetricRuleClassName = 'MetricRule';
exports.MetricRuleValueTypes = {
    Latest: 'latest',
    Averaged: 'averaged',
    Summed: 'bucketed',
};
exports.MetricRuleValueNames = {
    latest: 'Latest',
    averaged: 'Averaged',
    bucketed: 'Summed',
};
class MetricRule extends ModelCommon_1.ModelCommon {
    constructor(ob) {
        if (ob.type !== undefined && ob.type !== exports.MetricRuleClassName)
            throw new Error(`Tried to create a ${exports.MetricRuleClassName} from a ${ob.type} object!`);
        super(exports.MetricRuleClassName, ob);
        this.name = '';
        this.enabled = false;
        this.valueType = 'latest';
        this.max = { value: null };
        this.min = { value: null };
        this.stdDev = { value: null };
        this.type = ob.type ?? exports.MetricRuleClassName;
        if (ob) {
            const userAttDefs = this.getUserAttributes();
            Object.entries(userAttDefs).forEach(([key, def]) => {
                if (Object.getOwnPropertyDescriptor(def, 'default') && ob[key] === undefined) {
                    this[key] = def.default;
                }
            });
            Object.assign(this, ob);
        }
    }
    get deviceEnabledType() {
        return this._deviceEnabledType;
    }
    set deviceEnabledType(type) {
        this._deviceEnabledType = type;
    }
    get key() {
        return this._key;
    }
    set key(metric) {
        this._key = metric;
    }
    isSaveable() {
        return false;
    }
    getUserAttributes() {
        return {
            name: { type: 'String' },
            description: { type: 'String' },
            enabled: { type: 'Boolean', default: false },
            valueType: { type: 'Enum', default: exports.MetricRuleValueTypes.Latest, enumKv: exports.MetricRuleValueTypes },
            key: { type: 'String', label: 'Attribute' },
            max: { type: 'object', label: 'Maximum Threshold', default: { value: null } },
            min: { type: 'object', label: 'Minimum Threshold', default: { value: null } },
            stdDev: { type: 'object', label: 'Standard Deviation Threshold', default: { value: null } },
        };
    }
}
exports.MetricRule = MetricRule;
